export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        // text: 'NEW'
      }
    },

    {
      name: 'আবেদন',
      url: '/#',
      icon: 'fa fa-star',
      children: [
        {
          name: 'পানি',
          url: '/#',
          icon: 'fa fa-tint',
          children: [
            {
              name: 'নতুন সংযোগ',
              url: '/application/water/new-connection',
              icon: 'fa fa-plus'
            },
            {
              name: 'সংযোগ বাতিল',
              url: '/application/water/remove-connection',
              icon: 'fa fa-trash'
            },
            {
              name: 'হালনাগাদ সংযোগ',
              url: '/application/water/update-connection',
              icon: 'fa fa-refresh'
            }
          ]
        },
        {
          name: 'হোল্ডিং',
          url: '/holding',
          icon: 'fa fa-money',
          children: [
            {
              name: 'নতুন হোল্ডিং',
              url: '/holding/approved-list',
              icon: 'fa fa-object-ungroup'
            },
          ]
        },

      ]
    },
    {
      name: 'রিপোর্ট',
      url: '/report',
      icon: 'fa fa-bar-chart',
    }
  ],
}
